export class Option {
    constructor(
        public name: string,
        public value: any
    ){}
}

export class OptionGroup {
    constructor(
        public name: string,
        public values: Option[]
    ){}
}